<template lang='pug'>
div
    SignalGeneratorSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title CAL-IEC(-S)
            h2.product-subtitle Kalibrator für elektrische TE-Messung

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/CAL-IEC-S.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', width="50%", alt='TE-Kalibrator CAL-IEC-S', title='TE-Kalibrator CAL-IEC-S')

                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Referenzsignal für die Kalibrierung von elektrischen TE-Messsystemen
                            li Konform zu IEC 60270
                            li Mehrere pC-Bereichsoptionen
                            li Version für externe Injektionskapazitäten mit Spannungssprung-Ausgang gem. IEC 60270
                            li Lithium-Ionen-Akku
                            li Triggerarten: Photodiode, 100/120 Hz, 400/480 Hz, Single, TTL,  LWL
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt CAL-500.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet CAL-IEC.pdf")
                        Maillink(to='support@bss-hs.de', sub='CAL-IEC', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/pdm-80", text='TE-Monitoringsystem PDM-80')
                        Sitelink(to="/de/products/pdaccessories/calibratorcase", text='Zubehörset für CAL-IEC')
                    
        div.margin-bottom-30
            p Signalgenerator zur Erzeugung von Referenzsignalen mit definiertem Pegel für die Kalibrierung von Teilentladungsmessgeräten gemäß IEC60270.
            p Der CAL-IEC ist in mehreren pC-Bereichsoptionen und einer Version für externe Injektionskapazitäten mit Spannungssprung-Ausgang gem. IEC60270 verfügbar.
            p Das Ausgangssignal kann per TTL Signal, durch eine Fotodiode, durch einen manuellen Triggerknopf und durch die Fernsteuerung per LWL getriggert werden. Außerdem kann er auf eine feste Wiederholrate per internem Takt eingestellt werden. Der Referenzsignalgenerator wird per Lithium-Ionen-Akku betrieben und kann bei Bedarf komplett per LWL ferngesteuert werden.

        div.margin-bottom
            .column-container
                .column.align-top
                    span.bold Impulsform des Ladungsausgangs
                    p
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-IEC-charge.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-IEC-charge.webp') 
                        img( src='@/assets/photos/CAL-IEC-charge.png', width="80%", alt='CAL-IEC Ladungsausgang', title='CAL-IEC Ladungsausgang')
                    p
                    p 100 pC Ladungsimpuls:
                    ul
                        li gemessen an 50 Ω Eingang mit einem digitalen Speicheroszilloskop
                        li 100 pC bestimmt mit numerischer Integralmethode nach IEC 60270
                        
                .column.align-top
                    span.bold Impulsform des Spannungssprungausgangs CAL-IEC(-S)-V 
                    p
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-IEC-voltage.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-IEC-voltage.webp') 
                        img( src='@/assets/photos/CAL-IEC-voltage.png', width="80%", alt='CAL-IEC Spannungssprungausgang', title='CAL-IEC Spannungssprungausgang')
                    p
                    p 10 V Spannungsimpuls für die Verwendung von externer Injektionskapazität:
                    ul
                        li gemessen am 1 Meg Ω Eingang mit einem digitalen  Speicheroszilloskop
                        li Anstiegszeit < 60 ns
                        li Zeit bis zum eingeschwungenen Zustand < 200 ns
                        li Pulsdauer > 5 µs
                        li Impulsabfallzeit > 100 µs

            //- p Die Plots zeigen die verwendete Standard Impulsform des HFIG-600. Auf Anfrage können auch Versionen des Impulsgenerators mit einer Kapazitäts-Entladung mit langem Rücken oder mit einem Rechteckimpuls erzeugt werden. Kontaktieren Sie uns bei Bedarf.




    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title CAL-IEC(-S)
            h2.product-subtitle Calibrator for Electrical PD Measurement

        div.margin-bottom-30
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/CAL-IEC-S.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', width="50%", alt='PD Calibrator CAL-IEC-S', title='PD Calibrator CAL-IEC-S')
                    
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Reference signal for the calibration of electrical PD measurement systems
                            li IEC 60270 conform
                            li Various pC range options
                            li Version for external injection capacitors with step voltage output according to IEC 60270
                            li Lithium-ion battery-powered
                            li Trigger options: manual, photodiode, 100/120 Hz, 400/480 Hz, TTL, LWL

                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt CAL-500.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet CAL-IEC.pdf")
                        Maillink(to='support@bss-hs.de', sub='CAL-IEC', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/pdm-80", text='PD Monitoring System PDM-80')
                        Sitelink(to="/en/products/pdaccessories/calibratorcase", text='CAL-IEC Accessory Kit')
                    
                    
        div.margin-bottom
            p Reference signal generator with a defined signal level for the calibration of partial discharge measuring instruments according to IEC 60270.
            p Various pC range options and a version for external injection capacitors with step voltage output according to IEC 60270 available.
            p The signal can be triggered by a TTL signal, by a photodiode, by a manual trigger button and by the remote control via fiber optic (FO) cable. In addition, it can be set to a fixed repetition rate per internal clock. The pulse generator is operated by lithium-ion battery and can be controlled remotely by FO if required.

        div.margin-bottom
            .column-container
                .column.align-top
                    span.bold Charge Output
                    p
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-IEC-charge.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-IEC-charge.webp') 
                        img( src='@/assets/photos/CAL-IEC-charge.png', width="80%", alt='CAL-IEC Charge Output', title='CAL-IEC Charge Output')
                    p
                    p 100 pC pulse:
                    ul
                        li measured at 50 Ω input at a digital sampling oscilloscope
                        li 100 pC determined with numerical integral method acc. to IEC 60270
                        
                .column.align-top
                    span.bold Step Voltage Output CAL-IEC(-S)-V
                    p
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-IEC-voltage.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-IEC-voltage.webp') 
                        img( src='@/assets/photos/CAL-IEC-voltage.png', width="80%", alt='CAL-IEC Step Voltage Output', title='CAL-IEC Step Voltage Output')
                    p
                    p 10 V voltage pulse for the use of external injection capacitors
                    ul
                        li measured at 1 Meg Ω input at a digital sampling oscilloscope
                        li rise time is < 60 ns 
                        li time to steady state < 200 ns
                        li pulse duration > 5 µs
                        li pulse fall time > 100 µs
                        
            //- p The plots show the standard impulse shape of the HFIG-600. On request, versions of the pulse generator with a capacity discharge with a RC fall time or with a rectangular pulse can be provided. Contact us for additional information.

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | CAL-IEC",
            description:
                "Kalibrator für elektrische TE-Messung",
        },
        en: {
            title: "BSS | CAL-IEC",
            description:
                "Calibrator for Electrical PD Measurement",
        },
    },
};
</script>

<style lang='sass' scoped>
.heightauto
    object-fit: contain
</style>